module.exports = __webpack_public_path__ + "static/media/traversal-frame.2f25e6b5.png";